import React, { useState } from "react";
import Header from "./Header";

import {
  Box,
  HStack,
  Heading,
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
  Radio,
  RadioGroup,
  Stack,
  Button,
  Text,
  Flex,
  FormHelperText,
  Textarea,
} from "@chakra-ui/react";
import tokenABI from "./tokenABI.json";
import Loading from "./loading";
import axios from "axios";
import { serverURL } from "../server";
import Slider, { SliderTooltip } from "rc-slider";
import { BsCloudUpload } from "react-icons/bs";
import { FaEquals } from "react-icons/fa";
import { FcApproval } from "react-icons/fc";
import { useMediaQuery } from "@chakra-ui/media-query";
import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
import CSVReader from "react-csv-reader";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import DateTimePicker from "react-datetime-picker";
import moment from "moment";
import Environment from "../utils/Environment";
const papaparseOptions = {
  delimiter: "", // auto-detect
  newline: "", // auto-detect
  quoteChar: '"',
  escapeChar: '"',
  header: false,
  transformHeader: undefined,
  dynamicTyping: false,
  preview: 0,
  encoding: "",
  worker: false,
  comments: false,
  step: undefined,
  complete: undefined,
  error: undefined,
  download: false,
  downloadRequestHeaders: undefined,
  downloadRequestBody: undefined,
  skipEmptyLines: false,
  chunk: undefined,
  chunkSize: undefined,
  fastMode: undefined,
  beforeFirstChunk: undefined,
  withCredentials: undefined,
  transform: undefined,
  delimitersToGuess: [",", " ", "|", ";"],
};
const Sales = () => {
  const { Handle } = Slider;
  const {
    userWalletAddress = "",
    network = "",
    bnbBalance = 0,
    salesContract = "",
    web3,
  } = useSelector((state) => state.UserReducer);
  // TOKEN INFORMATION
  const [tokenAddress, setTokenAddress] = useState("");
  const [tokenSymbol, setTokenSymbol] = useState("");
  const [tokenDecimel, setTokenDecimel] = useState();
  const [tokenName, settokenName] = useState("");

  const [isnotSmallScreen] = useMediaQuery("(min-width:600px)");

  //  SALES INFORMATION
  const [hardCap, sethardCap] = useState("");
  const [tokensOnSale, settokensOnSale] = useState("");
  const [softCap, setsoftCap] = useState("");
  const [priceOfTokenOnSales, setPriceOfTokenOnSales] = useState("");
  const [startTime, setstartTime] = useState(new Date().getTime());
  const [endTime, setendTime] = useState(new Date().getTime());
  const [startTime1, setstartTime1] = useState(new Date());
  const [endTime1, setendTime1] = useState(new Date());
  const [saleDuration, setSaleDuration] = useState("");

  // WALLET ALLOCATION
  const [limit, setLimit] = useState("nolimit");
  const [minLimit, setMinLimit] = useState("");
  const [maxLimit, setMaxLimit] = useState("");

  // SALES TYPE
  const [sale, setSale] = useState("public");
  const [fileName, setfileName] = useState("No file chosen");
  const [fileData, setfileData] = useState([]);

  // Referral Percentage
  const [referralPercent, setreferralPercent] = useState("10");
  const [referral, setreferral] = useState("no");
  // VESTING SCHEDLE
  const [releasePercent, setreleasePercent] = useState("50");
  const [month, setMonth] = useState("");

  // PANCAKE LISTING
  const [liquidityPercent, setliquidityPercent] = useState("0");
  const [pancakeListingPrice, setPancakeListingPrice] = useState("");
  // ERROR STATE
  const [tokenError, settokenError] = useState(false);
  const [loading, setloading] = useState(false);

  // Additional info
  const [logoLink, setlogoLink] = useState("");
  const [webLink, setwebLink] = useState("");
  const [githubLink, setgithubLink] = useState("");
  const [twitterLink, settwitterLink] = useState("");
  const [redditLink, setredditLink] = useState("");
  const [telegramLink, settelegramLink] = useState("");
  const [projectDescription, setprojectDescription] = useState("");
  const [updateyouwant, setupdateyouwant] = useState("");
  const [projectName, setprojectName] = useState("");
  const [txHash, settxHash] = useState("");
  // VALIDATION FUNCTIONS STARTS FROM HERE
  const [totalNumber0fTokens, settotalNumber0fTokens] = useState("");
  const [tokenApproval, settokenApproval] = useState(false);
  const verifyTokenAdress = () => {
    if (tokenAddress.length === 42) {
      settokenError(false);
    } else {
      settokenError(true);
    }
  };
  const handleForce = (data, fileInfo) => {
    if (!fileInfo.name.includes(".txt") && !fileInfo.name.includes(".csv")) {
      toast.error("Error! Only .txt and .csv file is supported.");
    } else {
      setfileName(fileInfo.name);
      setfileData(data);
    }
  };
  const fileSelectedHandler = (event) => {
    console.log(event.target.files[0]);
    this.setState(
      {
        selectedFile: event.target.files[0],
      },
      () => this.fileUploadHandler()
    );
  };

  // FUNCTION FOR SLIDER TOOLTIP
  const handle = (props) => {
    const { value, dragging, index, ...restProps } = props;
    return (
      <SliderTooltip
        prefixCls="rc-slider-tooltip"
        overlay={`${value} %`}
        visible={dragging}
        placement="top"
        key={index}
      >
        <Handle value={value} {...restProps} />
      </SliderTooltip>
    );
  };
  console.log(endTime);
  const hiddenFileInput = React.useRef(null);

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    console.log("handleChange", fileUploaded);
  };
  const tokenAddressHandler = (address) => {
    settokenError(false);
    if (address.length == 42) {
      console.log("running");
      var Contracts;
      try {
        Contracts = new web3.eth.Contract(tokenABI, address);
      } catch (error) {
        setTokenDecimel("");
        setTokenSymbol("");
        toast.error("Error! Invalid token Address1");
        settokenError(true);
      }
      console.log(Contracts);
      if (Contracts) {
        Contracts &&
          Contracts.methods
            .decimals()
            .call()
            .then((val) => {
              console.log("token decimal", val);
              setTokenDecimel(val);

              if (!val) {
                toast.error("Error! Invalid token Address1");
                settokenError(true);
                return;
              }
            })
            .catch((err) => {
              settokenError(true);
              toast.error("Error! Invalid token Address");
            });
        Contracts &&
          Contracts.methods
            .name()
            .call()
            .then((val) => {
              settokenName(val);
              if (!val) {
                toast.error("Error! Invalid token Address");
                settokenError(true);
              }
            })
            .catch((err) => toast.error(err));
        Contracts &&
          Contracts.methods
            .symbol()
            .call()
            .then((val) => {
              console.log(val, "tokensymbol");
              setTokenSymbol(val);
              if (!val) {
                toast.error("Error! Invalid token Address");
                settokenError(true);
              }
            })
            .catch((err) => console.log(err.message));
      }
    } else {
      settokenError(true);
      toast.error("Error! Invalid token Address");
    }
  };
  console.log(fileData);
  const numberOfTokens = () => {
    if (!userWalletAddress) {
      toast.error("Error! Please connect your wallet ");
    }
    if (!priceOfTokenOnSales) {
      toast.error("Error! Please enter Price of tokens on sale ");
    } else if (!pancakeListingPrice) {
      toast.error("Error! Please enter Price of tokens on Pancakeswap ");
    } else if (!tokensOnSale) {
      toast.error("Error! Please enter Tokens for sale .");
    } else if (!+liquidityPercent > 0) {
      toast.error(
        "Error! Please select percentage of liquidity to be added to pool greater than zero"
      );
    } else {
      setloading(true);

      salesContract.methods
        .getTotalNumberOfTokens(
          priceOfTokenOnSales,
          pancakeListingPrice,
          tokensOnSale,
          liquidityPercent
        )
        .call()
        .then(async (val) => {
          settotalNumber0fTokens(val[0]);
          sethardCap(val[1]);
          console.log(val);
          setloading(false);
        })
        .catch((e) => {
          toast.error(e.message);
          setloading(false);
        });
    }
  };
  const tokenApprovalHandler = async () => {
    if (!userWalletAddress) {
      toast.error("Error! Please connect your wallet .");
    } else if (!totalNumber0fTokens) {
      toast.error("Error! Please get total number of tokens ");
    } else {
      setloading(true);
      const tokenContract = await new web3.eth.Contract(tokenABI, tokenAddress);
      const decimal = Math.pow(10, +tokenDecimel).toString();
      tokenContract.methods
        .approve(
          Environment.saleContractAddress,
          totalNumber0fTokens + decimal.slice(1)
        )
        .send({
          from: userWalletAddress,
        })
        .then((res) => {
          settxHash("https://testnet.bscscan.com/tx/" + res.transactionHash);
          settokenApproval(true);
          setloading(false);
        })
        .catch((e) => {
          toast.error(e.message);
          setloading(false);
        });
    }
  };
  const createPresaleHandler = async () => {
    if (!userWalletAddress) {
      toast.error("Error! Please connect your wallet ");
    } else if (!totalNumber0fTokens) {
      toast.error("Error! Please get total number of tokens.");
    } else if (!tokenApproval) {
      toast.error("Error! Please approve tokens.");
    } else if (!userWalletAddress) {
      toast.error("Error! Please connect your wallet");
    } else if (!tokenAddress) {
      toast.error("Error! Please enter token Adrress");
    } else if (tokenError) {
      toast.error("Error! Please enter valid token Adrress");
    } else if (!softCap) {
      toast.error("Error! Please enter Soft Cap.");
    } else if (!tokensOnSale) {
      toast.error("Error! Please enter tokens on sale.");
    } else if (
      +endTime < +startTime + 1800000 ||
      +endTime == +startTime + 1800000
    ) {
      toast.error(
        "Error! There must be a gap more than 30 minutes between sale start and end time."
      );
    } else if (+startTime + 1800000 < new Date().getTime() + 1800000) {
      toast.error(
        "Error! There must be a gap more than 30 minutes between sale start and the time right now."
      );
    } else if (limit == "limit" && (!minLimit || !maxLimit)) {
      toast.error("Error! Please enter all values of maxlimit and minlimit.");
    } else if (limit == "limit" && maxLimit < minLimit) {
      toast.error(
        "Error! Maximum Contribution limit must be greater than minimun contribution limit"
      );
    } else if (
      limit == "limit" &&
      (isNaN(+minLimit) || isNaN(+maxLimit) || +minLimit < 0 || +maxLimit < 0)
    ) {
      toast.error("Error! Please enter valid values of maxlimit and minlimit.");
    } else if (sale == "whitelist" && fileData.fileName == "No file chosen") {
      toast.error(
        "Error! Please select csv file of whitelist wallet addresses."
      );
    } else if (sale == "whitelist" && fileData.length == 0) {
      toast.error("Error! No data found in uploaded csv file.");
    } else if (!month) {
      toast.error("Error! Please enter total months in vestin schedule.");
    } else if (isNaN(+month) || +month < 0) {
      toast.error(
        "Error! Please enter valid value of months in vestin schedule."
      );
    } else if (!pancakeListingPrice) {
      toast.error("Error! Please enter pancake listing price.");
    } else if (isNaN(+pancakeListingPrice) || +pancakeListingPrice < 0) {
      toast.error("Error! Please enter valid pancake listing price.");
    } else if (
      !logoLink ||
      !webLink ||
      !twitterLink ||
      !projectName ||
      !telegramLink
    ) {
      toast.error(
        "Error! Please fill all required* additional informations correctly."
      );
    }
    // console.log(typeof (+endTime / 1000).toFixed(0));
    else {
      setloading(true);

      salesContract.methods
        .createPreSaleBNB(
          tokenAddress,
          releasePercent,
          month,
          referral == "no" ? "0" : referralPercent,
          limit == "nolimit" ? "0" : web3.utils.toWei(minLimit),
          limit == "nolimit" ? hardCap : web3.utils.toWei(maxLimit)
        )
        .send({ from: userWalletAddress })
        .then(async (val) => {
          salesContract.methods
            .setPreSaleBNB(
              tokenAddress,
              tokensOnSale,
              priceOfTokenOnSales,
              web3.utils.toWei(softCap),
              pancakeListingPrice,
              liquidityPercent
            )
            .send({ from: userWalletAddress })
            .then(async (val) => {
              axios
                .post(serverURL + "IOD", {
                  tokenAddress,
                  tokenSymbol,
                  tokenDecimel,
                  tokenName,
                  hardCap,
                  softCap,
                  priceOfTokenOnSales,
                  startTime,
                  endTime,
                  limit,
                  minLimit,
                  maxLimit,
                  sale,
                  fileData,
                  referralPercent,
                  referral,
                  releasePercent,
                  month,
                  liquidityPercent,
                  pancakeListingPrice,
                  projectName,
                  logoLink,
                  webLink,
                  githubLink,
                  twitterLink,
                  redditLink,
                  telegramLink,
                  projectDescription,
                  updateyouwant,
                })
                .then((res) => {
                  if (res.data.success) {
                    toast.success("Success! Sale successfully created.");
                    setloading(false);
                    window.location.reload();
                  }
                })
                .catch((error) => {
                  toast.error(error.message);
                  setloading(false);
                });
            })
            .catch((e) => {
              toast.error(e.message);
              setloading(false);
            });
        })
        .catch((e) => {
          toast.error(e.message);
          setloading(false);
        });
    }
  };
  return (
    <React.Fragment>
      <Loading open={loading} />
      {/* mx={[30, 30, 2, 30]} */}
      <Box
        h={"auto"}
        w={{
          // md: s0,
          sm: "100 %",
        }}
        bg="#EDFAFB"
      >
        <Box px={[2, 2, 2, 20]} mx={[2, 2, 2, 7]}>
          {/* TOKEN INFORMATION */}
          <Heading
            color="#00B7C5"
            fontSize={isnotSmallScreen ? "2xl" : "1xl"}
            py={10}
          >
            Token Information
          </Heading>
          <SimpleGrid columns={[1, null, 1]}>
            <Box my={2}>
              <FormControl id="first-name" isRequired>
                <HStack>
                  <Box width="195px" mb={tokenError ? "6" : ""}>
                    <FormLabel>Token Address</FormLabel>
                  </Box>
                  <Box width="1200px">
                    <Input
                      name="tokenAddress"
                      value={tokenAddress}
                      onChange={(e) => {
                        if (e.target.value.length == 42) {
                          tokenAddressHandler(e.target.value);
                        }
                        setTokenAddress(e.target.value);
                      }}
                      maxLength={42}
                      bg="white"
                      placeholder="Ex. 0x12345678910111213141516"
                    />
                    {tokenError && (
                      <FormHelperText>
                        Please enter a valid token address.
                      </FormHelperText>
                    )}
                  </Box>
                </HStack>
              </FormControl>
            </Box>
          </SimpleGrid>
          <SimpleGrid columns={[1, null, 2]} spacing="40px">
            <Box>
              <FormControl id="first-name" isRequired>
                <HStack>
                  <Box width="250px">
                    <FormLabel>Token Symbol</FormLabel>
                  </Box>
                  <Box width="600px">
                    <Input value={tokenSymbol} bg="white" readOnly />
                  </Box>
                </HStack>
              </FormControl>
            </Box>
            <Box>
              <FormControl id="first-name" isRequired>
                <HStack>
                  <Box width="250px">
                    <FormLabel>Token Decimal</FormLabel>
                  </Box>
                  <Box width="600px">
                    <Input value={tokenDecimel} bg="white" readOnly />
                  </Box>
                </HStack>
              </FormControl>
            </Box>
          </SimpleGrid>
          {/* SALES INFORMATION */}
          <Heading
            color="#00B7C5"
            fontSize={isnotSmallScreen ? "2xl" : "1xl"}
            py={10}
          >
            Referral Percentage %
          </Heading>
          <SimpleGrid>
            <Box my={2}>
              <HStack flexDirection={!isnotSmallScreen ? "column" : "row"}>
                <RadioGroup defaultValue={referral}>
                  <Stack spacing={10} direction="row">
                    <Radio
                      colorScheme="blue"
                      value={"no"}
                      onChange={() => setreferral("no")}
                    >
                      No
                    </Radio>
                    <Radio
                      colorScheme="blue"
                      value={"yes"}
                      onChange={() => setreferral("yes")}
                    >
                      Yes
                    </Radio>
                  </Stack>
                </RadioGroup>
              </HStack>
            </Box>
          </SimpleGrid>
          {referral == "yes" && (
            <SimpleGrid columns={[1, null, 1]}>
              <Box my={2}>
                <FormControl id="first-name">
                  <HStack flexDirection={!isnotSmallScreen ? "column" : "row"}>
                    <Box width={isnotSmallScreen ? "450px" : "auto"}>
                      <FormLabel fontSize="sm">Referral Percentage </FormLabel>
                    </Box>
                    <Box width={isnotSmallScreen ? "1000px" : "100%"} pb={4}>
                      <Slider
                        defaultValue={referralPercent}
                        trackStyle={{
                          backgroundColor: "#00B7C5",
                          height: 20,
                          borderRadius: 0,
                        }}
                        handleStyle={{
                          borderColor: "#00B7C5",
                          height: 30,
                          width: 30,
                          marginLeft: -11,
                          marginTop: -5,
                          backgroundColor: "white",
                        }}
                        railStyle={{
                          backgroundColor: "#E1E1E1",
                          height: 20,
                          borderRadius: 0,
                        }}
                        handle={handle}
                        onChange={(value) => setreferralPercent(value)}
                      />{" "}
                    </Box>
                  </HStack>
                </FormControl>
              </Box>
            </SimpleGrid>
          )}
          <Heading
            color="#00B7C5"
            fontSize={isnotSmallScreen ? "2xl" : "1xl"}
            py={10}
          >
            Sales Information
          </Heading>
          <SimpleGrid columns={[1, null, 1]}>
            <Box my={2}>
              <FormControl id="first-name">
                <HStack>
                  <Box width="300px">
                    <FormLabel fontSize="sm">Tokens for Sale</FormLabel>
                  </Box>
                  <Box width="300px">
                    <Input
                      textAlign="center"
                      bg="white"
                      placeholder="Ex. 10000 token"
                      value={tokensOnSale}
                      onChange={(e) => settokensOnSale(e.target.value)}
                    />
                  </Box>
                  <Box width="300px">
                    <FormLabel fontSize="sm">Tokens </FormLabel>
                  </Box>
                </HStack>
              </FormControl>
            </Box>
          </SimpleGrid>
          <SimpleGrid columns={[1, null, 1]}>
            <Box my={2}>
              <FormControl id="first-name">
                <HStack>
                  <Box width="300px">
                    <FormLabel fontSize="sm">Soft Cap</FormLabel>
                  </Box>
                  <Box width="300px">
                    <Input
                      textAlign="center"
                      bg="white"
                      placeholder="Ex. 5 BNB"
                      value={softCap}
                      onChange={(e) => setsoftCap(e.target.value)}
                    />
                  </Box>
                  <Box width="300px">
                    <FormLabel fontSize="sm">BNB </FormLabel>
                  </Box>
                </HStack>
              </FormControl>
            </Box>
          </SimpleGrid>
          <SimpleGrid columns={[1, null, 1]}>
            <Box my={2}>
              <FormControl id="first-name">
                <HStack>
                  <Box width="300px">
                    <FormLabel>
                      <HStack>
                        <Text fontSize="sm">
                          Price of tokens on sale &nbsp; &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp;1 BNB &nbsp; &nbsp; &nbsp; &nbsp;
                        </Text>
                        <FaEquals color="#00B7C5" />
                      </HStack>
                    </FormLabel>
                  </Box>
                  <Box width="300px">
                    <Input
                      textAlign="center"
                      bg="white"
                      placeholder="Ex. 1BNB = 100"
                      value={priceOfTokenOnSales}
                      onChange={(e) => setPriceOfTokenOnSales(e.target.value)}
                    />{" "}
                  </Box>
                  <Box width="300px">
                    <FormLabel fontSize="sm">Tokens </FormLabel>
                  </Box>
                </HStack>
              </FormControl>
            </Box>
          </SimpleGrid>
          <SimpleGrid columns={[1, null, 1]}>
            <Box my={2}>
              <FormControl id="first-name">
                <HStack>
                  <Box width="300px">
                    <FormLabel fontSize="sm">Sale Start Time</FormLabel>
                  </Box>
                  <Box width="300px">
                    <DateTimePicker
                      onChange={(e) => {
                        setstartTime(moment(e).format("x"));
                        setstartTime1(e);
                      }}
                      value={startTime1}
                      className="inputdatefield"
                    />
                  </Box>
                </HStack>
              </FormControl>
            </Box>
          </SimpleGrid>
          <SimpleGrid columns={[1, null, 1]}>
            <Box my={2}>
              <FormControl id="first-name">
                <HStack>
                  <Box width="300px">
                    <FormLabel fontSize="sm">Sale End Time</FormLabel>
                  </Box>
                  <Box width="300px">
                    <DateTimePicker
                      onChange={(e) => {
                        setendTime(moment(e).format("x"));
                        setendTime1(e);
                      }}
                      value={endTime1}
                      className="inputdatefield"
                    />
                  </Box>
                </HStack>
              </FormControl>
            </Box>
          </SimpleGrid>
          {/* PER WALLET ALLOCATION LIMIT */}
          <Heading color="black" fontSize="xl" py={10}>
            Per Wallet Allocation Limit
          </Heading>
          <SimpleGrid>
            <Box my={2}>
              <HStack flexDirection={!isnotSmallScreen ? "column" : "row"}>
                <RadioGroup defaultValue={limit}>
                  <Stack spacing={10} direction="row">
                    <Radio
                      colorScheme="blue"
                      value={"nolimit"}
                      onChange={() => setLimit("nolimit")}
                    >
                      No Limit
                    </Radio>
                    <Radio
                      colorScheme="blue"
                      value={"limit"}
                      onChange={() => setLimit("limit")}
                    >
                      Limit
                    </Radio>
                  </Stack>
                </RadioGroup>
                <Box
                  style={{ paddingLeft: isnotSmallScreen ? "7.4rem" : "0rem" }}
                >
                  <HStack
                    px={10}
                    borderRadius={"md"}
                    border="1px"
                    borderColor={"#00B7C5"}
                    flexDirection={!isnotSmallScreen ? "column" : "row"}
                  >
                    <Box>Min :</Box>
                    <Box width={"7rem"}>
                      {" "}
                      <Input
                        textAlign="center"
                        disabled={limit == "limit" ? false : true}
                        bg="white"
                        name="minLimit"
                        placeholder="Ex. 0.1 BNB"
                        value={minLimit}
                        onChange={(e) => setMinLimit(e.target.value)}
                      />
                    </Box>
                    <Box>BNB</Box>
                    <Box pl={isnotSmallScreen ? 10 : ""}>Max :</Box>
                    <Box width={"7rem"}>
                      {" "}
                      <Input
                        textAlign="center"
                        disabled={limit == "limit" ? false : true}
                        bg="white"
                        name="maxLimit"
                        placeholder="Ex. 5 BNB"
                        value={maxLimit}
                        onChange={(e) => setMaxLimit(e.target.value)}
                      />
                    </Box>{" "}
                    <Box>BNB</Box>{" "}
                  </HStack>
                </Box>
              </HStack>
            </Box>
          </SimpleGrid>
          {/* SALES TYPE */}
          <Heading color="black" fontSize="xl" py={10}>
            Sales Type
          </Heading>
          <SimpleGrid columns={[1, null, 1]}>
            <Box my={2}>
              <HStack flexDirection={!isnotSmallScreen ? "column" : "row"}>
                <RadioGroup defaultValue={"public"}>
                  <Stack spacing={10} direction="row">
                    <Radio
                      colorScheme="blue"
                      value={"public"}
                      onChange={() => setSale("public")}
                    >
                      Public
                    </Radio>
                    <Radio
                      colorScheme="blue"
                      value={"whitelist"}
                      onChange={() => setSale("whitelist")}
                    >
                      Whitelist Only
                    </Radio>
                  </Stack>
                </RadioGroup>
                <Box
                  style={{ paddingLeft: isnotSmallScreen ? "7.4rem" : "0rem" }}
                  display="flex"
                  alignItems="center"
                >
                  <CSVReader
                    cssClass="react-csv-input"
                    label="Upload CSV"
                    onFileLoaded={handleForce}
                    onClick={() => setfileName("No file chosen")}
                    parserOptions={papaparseOptions}
                    inputStyle={{
                      cursor: sale == "whitelist" ? "pointer" : "initial",
                    }}
                    disabled={sale == "whitelist" ? false : true}
                  />
                  &nbsp; <b>{sale == "whitelist" && fileName}</b>
                  {/* <FormHelperText>
                  Please enter a valid token address.
                </FormHelperText> */}
                </Box>
              </HStack>
            </Box>
          </SimpleGrid>
          {/* VESTING SCHEDLE */}
          <Heading
            color="#00B7C5"
            fontSize={isnotSmallScreen ? "2xl" : "1xl"}
            py={10}
          >
            Vesting Schedule
          </Heading>
          <SimpleGrid columns={[1, null, 1]}>
            <Box my={2}>
              <FormControl id="first-name">
                <HStack flexDirection={!isnotSmallScreen ? "column" : "row"}>
                  <Box width={isnotSmallScreen ? "450px" : "auto"}>
                    <FormLabel fontSize="sm">
                      % of tokens to be released at sale end time{" "}
                    </FormLabel>
                  </Box>
                  <Box width={isnotSmallScreen ? "1000px" : "100%"} pb={4}>
                    <Slider
                      defaultValue={releasePercent}
                      trackStyle={{
                        backgroundColor: "#00B7C5",
                        height: 20,
                        borderRadius: 0,
                      }}
                      handleStyle={{
                        borderColor: "#00B7C5",
                        height: 30,
                        width: 30,
                        marginLeft: -11,
                        marginTop: -5,
                        backgroundColor: "white",
                      }}
                      railStyle={{
                        backgroundColor: "#E1E1E1",
                        height: 20,
                        borderRadius: 0,
                      }}
                      handle={handle}
                      onChange={(value) => setreleasePercent(value)}
                    />{" "}
                  </Box>
                </HStack>
              </FormControl>
            </Box>
          </SimpleGrid>
          <SimpleGrid columns={[1, null, 1]}>
            <Box my={2}>
              <FormControl id="first-name">
                <HStack flexDirection={!isnotSmallScreen ? "column" : "row"}>
                  <Box width="130px">
                    <FormLabel fontSize="sm">Total Months </FormLabel>
                  </Box>
                  <Box width="110px">
                    <Input
                      textAlign="center"
                      bg="white"
                      placeholder="Ex. 4"
                      value={month}
                      onChange={(e) => setMonth(e.target.value)}
                    />
                  </Box>
                </HStack>
              </FormControl>
            </Box>
          </SimpleGrid>
          {/* PANCAKESWAP LISTING */}
          <Heading
            color="#00B7C5"
            fontSize={isnotSmallScreen ? "2xl" : "1xl"}
            py={10}
          >
            Pancakeswap Listing
          </Heading>
          <SimpleGrid columns={[1, null, 1]}>
            <Box my={2}>
              <FormControl id="first-name">
                <HStack flexDirection={!isnotSmallScreen ? "column" : "row"}>
                  <Box width={isnotSmallScreen ? "450px" : "auto"}>
                    <FormLabel fontSize="sm">
                      % of liquidity to be added to pool{" "}
                    </FormLabel>
                  </Box>
                  <Box width={isnotSmallScreen ? "1000px" : "100%"} pb={4}>
                    <Slider
                      defaultValue={liquidityPercent}
                      min={0}
                      max={100}
                      trackStyle={{
                        backgroundColor: "#00B7C5",
                        height: 20,
                        borderRadius: 0,
                      }}
                      handleStyle={{
                        borderColor: "#00B7C5",
                        height: 30,
                        width: 30,
                        marginLeft: -11,
                        marginTop: -5,
                        backgroundColor: "white",
                      }}
                      railStyle={{
                        backgroundColor: "#E1E1E1",
                        height: 20,
                        borderRadius: 0,
                      }}
                      handle={handle}
                      onChange={(value) => setliquidityPercent(value)}
                    />
                  </Box>
                </HStack>
              </FormControl>
            </Box>
          </SimpleGrid>
          <SimpleGrid columns={[1, null, 1]}>
            <Box my={2}>
              <FormControl id="first-name">
                <HStack>
                  <Box width="300px">
                    <FormLabel>
                      <HStack>
                        <Text fontSize="sm">
                          Price of tokens on Pancakeswap &nbsp; &nbsp;1 BNB
                        </Text>
                        <FaEquals color="#00B7C5" />
                      </HStack>
                    </FormLabel>
                  </Box>
                  <Box width="120px">
                    <Input
                      textAlign="center"
                      bg="white"
                      placeholder="Ex. 100"
                      value={pancakeListingPrice}
                      onChange={(e) => setPancakeListingPrice(e.target.value)}
                    />
                  </Box>
                  <Box width="300px">
                    <FormLabel fontSize="sm">Tokens </FormLabel>
                  </Box>
                </HStack>
              </FormControl>
            </Box>
          </SimpleGrid>
          <Heading
            color="#00B7C5"
            fontSize={isnotSmallScreen ? "2xl" : "1xl"}
            py={10}
          >
            Additional Information
          </Heading>
          <SimpleGrid columns={[1, null, 2]} my={6} spacing="40px">
            <Box>
              <FormControl id="first-name" isRequired>
                <HStack>
                  <Box width="250px">
                    <FormLabel>Project Name</FormLabel>
                  </Box>
                  <Box width="600px">
                    <Input
                      value={projectName}
                      bg="white"
                      onChange={(e) => setprojectName(e.target.value)}
                      placeholder="Ex. Cardence Sale"
                    />
                  </Box>
                </HStack>
              </FormControl>
            </Box>
            <Box>
              <FormControl id="first-name" isRequired>
                <HStack>
                  <Box width="250px">
                    <FormLabel>Logo Link</FormLabel>
                  </Box>
                  <Box width="600px">
                    <Input
                      value={logoLink}
                      bg="white"
                      onChange={(e) => setlogoLink(e.target.value)}
                      placeholder="Ex. https://www.cardence.io/logo.png"
                    />
                  </Box>
                </HStack>
              </FormControl>
            </Box>
          </SimpleGrid>
          <SimpleGrid columns={[1, null, 2]} my={6} spacing="40px">
            <Box>
              <FormControl id="first-name" isRequired>
                <HStack>
                  <Box width="250px">
                    <FormLabel>Website Link</FormLabel>
                  </Box>
                  <Box width="600px">
                    <Input
                      value={webLink}
                      bg="white"
                      onChange={(e) => setwebLink(e.target.value)}
                      placeholder="Ex. https://www.cardence.io"
                    />
                  </Box>
                </HStack>
              </FormControl>
            </Box>
            <Box>
              <FormControl id="first-name" isRequired>
                <HStack>
                  <Box width="250px">
                    <FormLabel>Twitter Link</FormLabel>
                  </Box>
                  <Box width="600px">
                    <Input
                      value={twitterLink}
                      bg="white"
                      onChange={(e) => settwitterLink(e.target.value)}
                      placeholder="Ex. https://www.twitter..."
                    />
                  </Box>
                </HStack>
              </FormControl>
            </Box>
          </SimpleGrid>
          <SimpleGrid columns={[1, null, 2]} my={6} spacing="40px">
            <Box>
              <FormControl id="first-name" isRequired>
                <HStack>
                  <Box width="250px">
                    <FormLabel>Telegram Link</FormLabel>
                  </Box>
                  <Box width="600px">
                    <Input
                      value={telegramLink}
                      bg="white"
                      onChange={(e) => settelegramLink(e.target.value)}
                      placeholder="Ex. https://t.me..."
                    />
                  </Box>
                </HStack>
              </FormControl>
            </Box>
            <Box>
              <FormControl id="first-name">
                <HStack>
                  <Box width="250px">
                    <FormLabel>Reddit Link</FormLabel>
                  </Box>
                  <Box width="600px">
                    <Input
                      value={redditLink}
                      bg="white"
                      onChange={(e) => setredditLink(e.target.value)}
                      placeholder="Ex. https://www.Reddit..."
                    />
                  </Box>
                </HStack>
              </FormControl>
            </Box>
          </SimpleGrid>
          <SimpleGrid columns={[1, null, 2]} my={6} spacing="40px">
            <Box>
              <FormControl id="first-name">
                <HStack>
                  <Box width="250px">
                    <FormLabel>Medium Link</FormLabel>
                  </Box>
                  <Box width="600px">
                    <Input
                      value={githubLink}
                      bg="white"
                      onChange={(e) => setgithubLink(e.target.value)}
                      placeholder="Ex. https://www.medium..."
                    />
                  </Box>
                </HStack>
              </FormControl>
            </Box>
          </SimpleGrid>
          <SimpleGrid columns={[1, null, 2]} my={6} spacing="40px">
            <Box>
              <FormControl id="first-name">
                <HStack>
                  <Box width="250px">
                    <FormLabel>Project Decription</FormLabel>
                  </Box>
                  <Box width="600px">
                    <Textarea
                      value={projectDescription}
                      bg="white"
                      onChange={(e) => setprojectDescription(e.target.value)}
                    />
                  </Box>
                </HStack>
              </FormControl>
            </Box>
            <Box>
              <FormControl id="first-name">
                <HStack>
                  <Box width="250px">
                    <FormLabel>Updates you want</FormLabel>
                  </Box>
                  <Box width="600px">
                    <Textarea
                      value={updateyouwant}
                      bg="white"
                      onChange={(e) => setupdateyouwant(e.target.value)}
                    />
                  </Box>
                </HStack>
              </FormControl>
            </Box>
          </SimpleGrid>
          <Button
            px={0}
            my={5}
            color="#00B7C5"
            bg="transparent"
            fontSize={isnotSmallScreen ? "2xl" : "1xl"}
            fontWeight={"bold"}
            _hover={{
              bg: "transparent",
            }}
            _focus={{
              boxShadow: "none",
            }}
            onClick={numberOfTokens}
          >
            No of tokens to be approved
            {totalNumber0fTokens && ":" + totalNumber0fTokens}
          </Button>

          <br />
          <Button
            px={0}
            my={5}
            color="#00B7C5"
            fontWeight={"bold"}
            bg="transparent"
            fontSize={isnotSmallScreen ? "2xl" : "1xl"}
            _hover={{
              bg: "transparent",
            }}
            _focus={{
              boxShadow: "none",
            }}
            onClick={tokenApprovalHandler}
          >
            Get token approval{" "}
            {tokenApproval && (
              <FcApproval style={{ fontSize: "30px", marginLeft: "20px" }} />
            )}
          </Button>

          <br />
          <Button
            my={5}
            px={0}
            fontWeight={"bold"}
            color="#00B7C5"
            bg="transparent"
            fontSize={isnotSmallScreen ? "2xl" : "1xl"}
            _hover={{
              bg: "transparent",
            }}
            _focus={{
              boxShadow: "none",
            }}
          >
            Check approval transaction
            {tokenApproval && (
              <a href={txHash} target="_blank">
                <Button
                  bg="#00B7C5"
                  color="white"
                  width={[
                    "100%", // base
                    "100%", // 480px upwards
                    "50%", // 768px upwards
                    "15rem", // 992px upwards
                  ]}
                  ml="10px"
                >
                  View on BscScan
                </Button>
              </a>
            )}
          </Button>
          <br />
          <Button
            my={5}
            px={0}
            fontWeight={"bold"}
            color="#00B7C5"
            bg="transparent"
            fontSize={isnotSmallScreen ? "2xl" : "1xl"}
            _hover={{
              bg: "transparent",
            }}
            _focus={{
              boxShadow: "none",
            }}
            onClick={createPresaleHandler}
          >
            Deploy Sale contract
          </Button>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default Sales;
